module.exports = __webpack_public_path__ + "img/icon-threshold.c39d4cac.svg";